import React, { useState } from "react";
import "./SilverInvestmentDetails.css";
import backtick from "../../../../../assets/backtick.svg";
import successicon from "../../../../../assets/success-icon.svg";
import { Link } from "react-router-dom";
import { showModal } from "../../../../../../../../redux/actions/modal.action";
import { connect } from "react-redux";
import { Util } from "../../../../../../../../helpers/util";

const InvestNow = ({ toggleModalAppearance }) => {
  const currency = Util.getCurrency();
  const openModal = () => {
    toggleModalAppearance();
    console.log("Open redux");
  };
  const [showRoiInfo, setShowRoiInfo] = useState(false);
  return (
    <div className="startinvestment-body">
      <div className="startinvestment-main">
        <div className="confirminvestment-main">
          <h5 className="confirminvestment-h5"> Invest Now</h5>
          <p className="confirminvestment-textbody mt-2">
            Choose Payment Method
          </p>
        </div>
        <div className="silverplan">
          <p className="fundwith-header">Fund With</p>
          <hr className="hr" />
          <div className="silverplan-flex">
            <div className="ovest-wallet">
              <p className="ovestwallet-main">Ovest Wallet</p>
              <div className="investamount">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* should be render conditionally */}
                  <p className="investamount-balance mt-4">Balance: N0</p>
                  <p className="now-matured mt-4">Balance: N20,000,000</p>
                </div>

                <p className="investamount-mini mb-2">
                  Change this{" "}
                  <span>
                    <img src={backtick} alt="" className="ml-2" />
                  </span>{" "}
                </p>
              </div>
              <p className="funds-p mt-5">
                Insufficient funds. <span onClick={openModal}>Fund wallet</span>
              </p>
            </div>
          </div>
        </div>
        <div className="note-main p-4">
          <p className="funds-deduction">
            Funds will be deducted automatically from your available payment
            method(s) on OVest.
          </p>
        </div>
        <div className="checkbox-main">
          <input type="checkbox" name="" id="" className="checkbox-input" />
          <label htmlFor="" className="termsandcondition">
            By clicking this, you’ve agreed to
            <Link to ="/terms">
              <span> OVest terms and conditions</span>
            </Link>
          </label>
        </div>
        <button className="claim-property">Securely Invest N50,000</button>
        <button className="invest" onClick={() => setShowRoiInfo(true)}>
          Securely Invest 50.000
        </button>
      </div>
      <div
        className={`silverinvestment__roi-info-bg ${
          showRoiInfo ? "show-roi-info" : ""
        }`}
      >
        <div className="silverinvestment__roi-info-content">
          <div className="profit-roi-modal">
            <div className="p">
              <div className="success-img-icon">
                <img
                  src={successicon}
                  alt="close-modal"
                  className="close-icon-btn"
                  onClick={() => setShowRoiInfo(false)}
                />
              </div>
              <p className="profit-roi-textbody pl-5 pr-5">
                You have successfully subscribed to Silvest Investment plan with
                <span> {currency}50,000 </span> debited from your OVest wallet
              </p>
              <div className="go-to-dashboard">
                <Link to="/dashboard">
                  <button className="go-to-dashboard-btn">
                    Go to Dashboard
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  toggleModalAppearance: () => dispatch(showModal()),
});

export default connect(null, mapDispatchToProps)(InvestNow);
